import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import React from 'react';
import { ScrollPassWrapper } from '../../../components/scroll-pass-wrapper/scroll-pass.wrapper';
import { ContactForm } from './contact-form';

const useStyles = makeStyles(({ palette, breakpoints, spacing }) => ({
  root: {
    [breakpoints.up('md')]: {
      marginLeft: spacing(8),
      marginRight: spacing(8),
    },
  },
  descriptionContainer: {
    [breakpoints.down('md')]: {
      marginLeft: spacing(2),
      marginRight: spacing(2),
    },
  },
  formContainer: {
    flexGrow: 1,
    [breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  formBackground: {
    height: 627,
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    background: 'url(./discount-offer/discount-offer-background-mobile.svg)',
    backgroundRepeat: 'no-repeat',
    color: palette.primary.contrastText,
    backgroundPosition: 'center',
    backgroundSize: '100% 100%',
    [breakpoints.up('sm')]: {
      background: 'url(./discount-offer/discount-offer-background-desktop.svg)',
      backgroundRepeat: 'no-repeat',
      maxWidth: 588,
    },
  },
  formBox: {
    height: 208,
  },
}));

const handleSectionVisible = () => {
  trackCustomEvent({
    category: "Discount Offer",
    action: "Scroll",
    label: "Saw the section",
  })
}

export const DiscountOffer = () => {
  const classes = useStyles();
  return (
    <Grid container className={classes.root}>
      <Grid item className={classes.descriptionContainer} sm={12} md={4}>
        <Typography variant="h5">Exclusive Offer</Typography>
        <Box mt={3} />
        <ScrollPassWrapper onVisible={handleSectionVisible}>
          <Typography>
            Exciting news to share!
            <br /> We offer a 15% discount on the first month of training along
            with a 7 Day FREE trial. You will be notified when the free trial is
            about to expire, so you can decide if you want to proceed further. Our
            trainers cannot wait to start this journey together!
          </Typography>
        </ScrollPassWrapper>
      </Grid>
      <Grid item className={classes.formContainer} sm={12} md={8}>
        <Box className={classes.formBackground}>
          <Typography style={{ maxWidth: 237 }} variant="h5">
            Get a 15% discount on the first month of training
          </Typography>
          <Box mt={3} />
          <ContactForm />
        </Box>
      </Grid>
    </Grid>
  );
};
